import {observer} from 'mobx-react-lite';
import {SortableContextItemProps} from '../../../../entity/props/document/sortable-context-item-props';
import {SortableContext, verticalListSortingStrategy} from '@dnd-kit/sortable';
import {UniqueIdentifier} from '@dnd-kit/core';
import SortableItem from './SortableItem';
import {useService} from '../../../../infrastructure/service/service';
import React from 'react';
import {Typography} from '@mui/material';

import '../../../../assets/css/document/accordion-document.css';

export const SortableContextItem = observer((props: SortableContextItemProps): JSX.Element => {
  const {sectionService, titleService, documentService, titleTemplateService} = useService();
  const selectedIds = sectionService.getSelectedIds();

  const filterItems = (items: UniqueIdentifier[]): UniqueIdentifier[] => {

    if (!props.activeId)
      return items;

    return items.filter((id: UniqueIdentifier): boolean => id === props.activeId || !selectedIds.includes(id));
  }

  const findContainer = (id: UniqueIdentifier): string | undefined => {
    if (id in props.items)
      return id as string;

    return Object.keys(props.items).find((key: string): boolean => props.items[key].includes(id));
  }

  const handleSelect = (id: string): void => {
    if (!documentService.getDocumentMoving() && !sectionService.getViewDocument() && !documentService.getDocument() && id !== documentService.getDocument()?.id) {
      let updatedSelectedIds: UniqueIdentifier[];

      if (selectedIds.includes(id))
        updatedSelectedIds = selectedIds.filter((value: any) => value !== id);
      else
      if (selectedIds.length > 0 && findContainer(id) !== findContainer(selectedIds[0]))
        updatedSelectedIds = [id];
      else
        updatedSelectedIds = [...selectedIds, id];

      sectionService.setSelectedIds(updatedSelectedIds);
    }
  }

  return props.items[props.containerId] && props.items[props.containerId].length > 0
    ? <SortableContext items={ filterItems(props.items[props.containerId])} strategy={verticalListSortingStrategy}>
        {
          filterItems(props.items[props.containerId]).map((documentId: UniqueIdentifier): JSX.Element => (
            <SortableItem
              dragging={props.containerId === props.activeId}
              sections={props.project ? titleService.getTitle()?.sections ?? [] : titleTemplateService.getTitleTemplate()?.sections ?? []}
              key={documentId}
              id={documentId}
              titleId={titleService.getTitle()?.id || ''}
              onSelect={handleSelect}
              selected={selectedIds && selectedIds.length > 0 && selectedIds.includes(documentId)}
              project={props.project}
              items={props.items}
              setItems={props.setItems}/>
          ))
        }
      </SortableContext>
    : <Typography className={'empty-document'}>There are no documents to display</Typography>
  }
);
